export default {
  items: [
    {
      title: true,
      name: "Overview"
    },
    {
      name: "Home",
      url: "/dashboard",
      icon: "icon-home",
      id: "sidebar-home"
      // badge: {
      //   variant: "primary",
      //   text: "NEW"
      // }
    },

    {
      title: true,
      name: "Account"
    },
    {
      name: "Account Settings",
      url: "/account",
      icon: "icon-settings",
      id: "sidebar-account_settings"
    },
    {
      name: "Licenses",
      url: "/licenses",
      icon: "icon-list",
      id: "sidebar-licenses"
    },
    {
      name: "Billing",
      url: "/billing",
      icon: "icon-wallet",
      id: "sidebar-billing"
    },
    {
      name: "Meetings",
      url: "/meetings",
      icon: "icon-calendar",
      id: "sidebar-meetings",
      badge: {
        variant: "primary",
        text: "beta"
      }
    },
    {
      name: "Chat",
      url: "/chat",
      icon: "icon-bubbles",
      id: "sidebar-chat"
    },
    {
      name: "Contacts",
      url: "/contacts",
      icon: "icon-people",
      id: "sidebar-contacts"
    },
    {
      name: "Organization",
      url: "/org",
      icon: "icon-organization",
      id: "sidebar-organization"
    },
    {
      name: "App Logs",
      url: "/app-logs",
      icon: "icon-docs",
      id: "sidebar-app-logs"
    },

    {
      permission: ["audit.access", "license.create", "org.list", "user.switch"],
      title: true,
      name: "Admin"
    },
    {
      permission: "audit.access",
      name: "Audit Log",
      url: "/admin/audit-log",
      icon: "icon-list"
    },
    {
      permission: "license.create",
      name: "Create License",
      url: "/admin/create-license",
      icon: "icon-plus"
    },
    {
      permission: "org.list",
      name: "Organizations",
      url: "/admin/organizations",
      icon: "icon-organization"
    },
    {
      permission: "role.access",
      name: "Roles & Permissions",
      url: "/admin/roles",
      icon: "icon-people"
    },
    {
      permission: "user.search",
      name: "Search Users",
      url: "/admin/search",
      icon: "icon-magnifier"
    },

    {
      title: true,
      name: "Other"
    },
    {
      name: "Nanome Docs",
      url: "https://docs.nanome.ai",
      icon: "icon-book-open",
      id: "sidebar-docs",
      target: "_blank"
    },
    {
      name: "Help & Support",
      url: "https://docs.nanome.ai/help/troubleshooting.html",
      icon: "icon-bubbles",
      id: "sidebar-help&support",
      target: "_blank"
    }
  ]
};
